import React from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark header-nav">
      <div className="container-fluid">
        <Link className="navbar-brand logo" to="/">
          <img src="/images/logo.png" alt="RemoteRef Logo" />
        </Link>
        <div className="d-flex align-items-center order-lg-last ms-auto">
          <Link to="/booking" className="btn btn-schedule me-3">Schedule A Demo</Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav mx-auto nav-links">
            <li className="nav-item">
              <Link className={`nav-link ${isActive("/")}`} to="/">
                Home <i className="fa-solid fa-plus"></i>
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive("/features")}`} to="/">
                Key Features <i className="fa-solid fa-plus"></i>
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive("/how-it-works")}`} to="/">
                How it works <i className="fa-solid fa-plus"></i>
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive("/reviews")}`} to="/">
                Reviews <i className="fa-solid fa-plus"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
